import React, { useEffect, useState } from "react";
import { dateIncludeTime } from "utils/formatter/dateFormat";
import { examStatusTagOnlyText } from "utils/tagRender";
import useGetQueryhr from "./useGetQueryhr";
import { roomDetailsAtom } from "recoil/store";
import { useRecoilValue } from "recoil";

const COPY_SUCCESS_MESSAGE = "클립보드에 복사되었습니다.";
const COPY_FAIL_MESSAGE = "클립보드에 복사를 실패하였습니다.";

const useCopyClipboard = (useFrom) => {
  const roomDetail = useRecoilValue(roomDetailsAtom);
  const [param, setParam] = useState({ testerIdx: null });
  const { data, pageInfo, isLoading, isFetching } = useGetQueryhr("originInfo", param, param.testerIdx ? true : false);

  const [copyResult, setCopyResult] = useState(false);
  const [isCopyError, setIsCopyError] = useState(false);
  const [copyResultMessage, setCopyResultMessage] = useState("");
  const handleCloseAlert = () => setCopyResult(!copyResult);

  const fetchOriginGroupIdx = async (data) => setParam((prev) => ({ ...prev, testerIdx: data.testerIdx }));

  const handleCopyClipBoard = async (text) => {
    // setContent(text);

    if (useFrom === "roomTesterList") {
      // const text = content;
      const { companyName, groupName, examSAt } = roomDetail;
      const { testerName, testerBirth, testerCell, roomNo, preExamYN, foreignLoginYN, examStatus, groupIdx } = text;
      if (roomDetail.virtualGroupYN === "Y") {
        // await fetchOriginGroupIdx(text);
        // if (data) {
        //   const originIdx = data.realGroupIdx;
        const copyText = `${groupIdx} / ${companyName} / ${roomNo}번룸 / ${testerName} / ${testerBirth} / ${testerCell}`;
        await navigator.clipboard.writeText(copyText);
        setCopyResult(true);
        setCopyResultMessage(COPY_SUCCESS_MESSAGE);
        // }
      } else {
        const copyText = `${companyName} / ${roomNo}번룸 / ${testerName} / ${testerBirth} / ${testerCell}`;
        await navigator.clipboard.writeText(copyText);
        setCopyResult(true);
        setCopyResultMessage(COPY_SUCCESS_MESSAGE);
      }
    } else {
      // const text = content;
      const { companyName, groupIdx, groupName, testerName, examSAt, testerBirth, testerCell, roomNo, preExamYN, foreignLoginYN, examStatus } = text;
      const copyText = `${groupIdx} / ${companyName} / ${roomNo}번룸 / ${testerName} / ${testerBirth} / ${testerCell}`;
      await navigator.clipboard.writeText(copyText);
      setCopyResult(true);
      setCopyResultMessage(COPY_SUCCESS_MESSAGE);
    }
  };

  return {
    copyResultMessage,
    copyResult,
    handleCopyClipBoard,
    handleCloseAlert,
    isCopyError,
  };
};

export default useCopyClipboard;
